function scrolling() {

  $(".scrolling-slides").slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: "linear",
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false,
    pauseOnHover: true,
  });
}
/*===== section:load:event */
document.addEventListener("DOMContentLoaded", function () {
  scrolling();
//   productGallery();
});
document.addEventListener("shopify:section:load",function(){
  scrolling();
//   productGallery();
});